import { render, staticRenderFns } from "./walker-sitter-profile-container.vue?vue&type=template&id=c60b8e72&scoped=true&lang=pug"
import script from "./walker-sitter-profile-container.js?vue&type=script&lang=js&external"
export * from "./walker-sitter-profile-container.js?vue&type=script&lang=js&external"
import style0 from "./walker-sitter-profile-container.vue?vue&type=style&index=0&id=c60b8e72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60b8e72",
  null
  
)

export default component.exports